module.exports = __webpack_public_path__ + "img/SCN-ntc-conversion-formula-12pt.19a63a11.svg";